<section class='demo-text title-animation'>
    <div class='wrapper text'>
        <h2>{{data_title}}</h2>
<!--        <h2>{{data_aiuppie.type === 1?indoor:outdoor}}</h2>-->
    </div>
</section>
